import api from "@/services/api"

export const checkUnlinkedRefund = async (input: {
  amount: number
}) => {
  return await api.post<
    { allowed: true } | { allowed: false; error: string }
  >("/transactions/unlinked-refunds/check", {
    body: input,
  })
}
